import styled from 'styled-components';

const Title = styled.h1`
    color:#474747;
    padding: 15px;
    font-size: 5rem;
`;

export default Title;